import { render, staticRenderFns } from "./FlowDownTemplateEditor.vue?vue&type=template&id=b88e62da&scoped=true"
import script from "./FlowDownTemplateEditor.vue?vue&type=script&lang=js"
export * from "./FlowDownTemplateEditor.vue?vue&type=script&lang=js"
import style0 from "./FlowDownTemplateEditor.vue?vue&type=style&index=0&id=b88e62da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88e62da",
  null
  
)

export default component.exports